import React, { Fragment, useContext } from 'react';
import styled from 'styled-components';
import { H3 } from 'components/Heading';
import Icon from 'components/Icon';
import useTheme from 'hooks/useTheme';
import { AppContext } from 'shared/AppContext';

const SideDrawer = styled.div`
  height: 100%;
  background: white;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  border: 1px solid #e6e6e6;
  position: fixed;
  top: 0px;
  right: 0;
  width: 100%;
  z-index: 200;
  transform: ${(props) =>
    props.isVisible ? 'translateX(0%)' : 'translateX(100%)'};
  transition: transform 0.3s ease-out;
  overflow-y: auto;

  @media (min-width: 860px) {
    width: 520px;
  }

  @media (max-width: 860px) {
    height: calc(100% - 60px);
    top: 60px;
  }
`;

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 100;
  height: calc(100%);
  width: ${(props) =>
    props.navIsExpanded ? 'calc(100% - 200px)' : 'calc(100% - 50px)'};
  margin-left: ${(props) => (props.navIsExpanded ? '200px' : '50px')};
  display: ${(props) => (props.isVisible ? 'block' : 'none')};

  @media (max-width: 860px) {
    display: none;
  }
`;

const DrawerHeading = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 40px 20px 20px 20px;

  @media (min-width: 860px) {
    padding: 40px;
  }
`;

export const Drawer = ({ isVisible, title, children, handleOutClick }) => {
  const theme = useTheme();

  const {
    state: { navIsExpanded },
  } = useContext(AppContext);

  return (
    <Fragment>
      <Overlay
        /* onClick={handleOutClick} */ isVisible={isVisible}
        navIsExpanded={navIsExpanded}
      />
      <SideDrawer isVisible={isVisible}>
        <DrawerHeading>
          <H3 color="#3C4144">{title}</H3>
          <Icon
            icon="close"
            size={20}
            color={theme.colors.primary}
            onClick={handleOutClick}
          />
        </DrawerHeading>

        {children}
      </SideDrawer>
    </Fragment>
  );
};
